// extracted by mini-css-extract-plugin
export default {"mark":"ExclamationMark_mark__syYcH"};